import {
  emptyFilterCriteria,
  FilterCriteriaDto,
} from '@/components/table/types/FilterCriteriaDto.tsx';
import { FieldType } from '@/components/table/_fieldDefinitions/FieldType.ts';
import { FilterFieldOperator } from '@/components/table/_filterFieldOperators/FilterFieldOperator.ts';

export const PENDING_TRANSFERS_PAGE_SIZE = 50;

/** Krótsza fraza zwraca całą listę — tak samo jak wyszukiwarka tabeli. */
export const PENDING_TRANSFERS_SEARCH_MIN_LENGTH = 2;

/**
 * Zakres przelewów, które da się wpiąć w wydatek: oczekujące obciążenia.
 *
 * Status bierzemy szybkimi filtrami z definicji tabeli „Zaimportowane”
 * (`hideMatched` + `hideIgnored`), bo razem zostawiają dokładnie `PENDING`.
 * Znak odsiewamy po stronie backendu (`amount < 0`), a nie na pobranej
 * stronie — przy filtrowaniu u siebie wpłaty zjadałyby miejsca w stronie
 * i lista gubiłaby obciążenia, których użytkownik szuka.
 */
export const pendingTransfersFilterCriteria = (
  searchTerm: string,
): FilterCriteriaDto => {
  const trimmed = searchTerm.trim();

  return {
    ...emptyFilterCriteria,
    searchTerm:
      trimmed.length >= PENDING_TRANSFERS_SEARCH_MIN_LENGTH ? trimmed : '',
    filters: [
      {
        fieldId: 'amount',
        type: FieldType.MONEY_VALUE,
        operator: FilterFieldOperator.LESS_THAN,
        value: '0',
      },
    ],
    quickFilters: { hideMatched: true, hideIgnored: true },
  };
};
